import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import addDomainToPath from 'commons/addDomainToPath';
import useProductAttributes from 'data-hooks/useProductAttributes';
import PDPProductDetailsModalUI from './PDPProductDetailsModalUI';
const PDPProductDetailsModal = t0 => {
  const $ = _c(12);
  const {
    isOpen,
    onClose
  } = t0;
  const {
    loading,
    error,
    data: t1
  } = useProductAttributes();
  const {
    id,
    productPDF,
    constructionDetails,
    productCareDetails,
    additional_attributes,
    assemblyDetailsPDF
  } = t1;
  if (error) {
    return null;
  }
  const t2 = productPDF ? `https://jb-img.co/public_img/${productPDF}` : undefined;
  const t3 = assemblyDetailsPDF ? `https://jb-img.co/public_img/${assemblyDetailsPDF}` : undefined;
  let t4;
  if ($[0] !== additional_attributes || $[1] !== id) {
    t4 = additional_attributes?.fet_right_img ? addDomainToPath(`/products_additional/${id}/${encodeURIComponent(additional_attributes.fet_right_img)}`) : null;
    $[0] = additional_attributes;
    $[1] = id;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== constructionDetails || $[4] !== isOpen || $[5] !== loading || $[6] !== onClose || $[7] !== productCareDetails || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <PDPProductDetailsModalUI isOpen={isOpen} onClose={onClose} loading={loading} productDetails={constructionDetails} productCare={productCareDetails} tearSheetLink={t2} assemblyDetailsLink={t3} productImage={t4} />;
    $[3] = constructionDetails;
    $[4] = isOpen;
    $[5] = loading;
    $[6] = onClose;
    $[7] = productCareDetails;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
PDPProductDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};
export default PDPProductDetailsModal;